import { render } from "./SingleStat.vue?vue&type=template&id=32f79ae1&scoped=true"
import script from "./SingleStat.vue?vue&type=script&lang=js"
export * from "./SingleStat.vue?vue&type=script&lang=js"

import "./SingleStat.vue?vue&type=style&index=0&id=32f79ae1&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-32f79ae1"]])

export default __exports__